import {SuiModalService, TemplateModalConfig, ModalTemplate} from 'ng2-semantic-ui';
import { ActivatedRoute, Params, NavigationExtras, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import * as moment from 'moment';

import { DataService } from '../user-detail.service';
import { AttendanceStatusService } from './attendance-status.service';

export interface IContext {
  data:string;
}

@Component({
  selector: 'app-attendance-status',
  templateUrl: './attendance-status.component.html',
  styleUrls: ['./attendance-status.component.css']
})
export class AttendanceStatusComponent implements OnInit {
  @ViewChild('modalTemplate') public modalTemplate:ModalTemplate<IContext, string, string>

  statuses: any = [];
  rows = 0;
  user: any;
  isloading: Boolean = false;
  // staffId: number = 0;
  isMobile = window.innerWidth <= 420 ? true : false;
  finalData = [];
  // morningMeetings = [];
  tz_offset = new Date().getTimezoneOffset();
  groups = [];
  staffs = [];

  _from = moment().startOf('month').toDate();
  _to = moment().endOf('month').toDate();


  // updateTimeout: any = null;
  // pendingUpdateMeetingId = '';  // hold the current meeting Id while waiting for the time to update (1.5s)

  // subscription
  basicSetting: Subscription;
  getActiveStaffs: Subscription;

  selected_group = "";
  search = "";
  show_morning_meeting_notif = true;

  constructor(
    private attendanceStatusService: AttendanceStatusService,
    private activatedRoute: ActivatedRoute,
    public modalService:SuiModalService,
    private dataService: DataService,
    private router: Router
  ) { }


  ngOnInit() {
    this.user = this.dataService.getStaffInformation;
    this.activatedRoute.data.subscribe((result: any) => {
      console.log(result);

      // get the staffs from stafflist resolver
      this.staffs = result.staffs && result.staffs.data ? result.staffs.data : [];

      // get the groups from groupList resolver
      if (result.groups && result.groups.group) {
        this.groups = result.groups.group;
        let removeGroups = ['63cdef08cd7a2a75def4f975', '63d09893cd7a2a75def4fa14', '63d09900cd7a2a75def4fa15'];
        let count = 0;
        
        // merge "リーダー承認" and replace with "リーダーグループ"
        for (let i = 0; i < this.groups.length; i++) {
          if (removeGroups.includes(this.groups[i]['_id'])) {
            this.groups.splice(i, 1);
            count++;
            i--;

            if (count == 3) {
              i++;

              // add "リーダーグループ" to replace the remove groups
              this.groups.splice(i, 0, {
                group_name: "リーダーグループ",
                _id: 'leader'
              })
            }

          }
        }

        this.groups.unshift({_id: "all", group_name: "全社"});
      }

      this.activatedRoute.queryParams.subscribe((params: Params) => this.queryParamsHandler(params));
    })
  }

  getAttendanceStatus(staffid: any = this.user._id, search: any[], group: string) {
    this.isloading = true;
    this.attendanceStatusService.getAttendanceStatus(staffid, search, group).subscribe(
      resp => {
        if (resp && resp['success']) {
          this.finalData = resp['data'];
          this.isloading = false;
        }
        
      }
    )
  }

  // table filters
  onSelectGroup(e) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
          search: this.search,
          group: e
      },
      queryParamsHandling: 'merge'
    };
    this.router.navigate(['/attendance-status'], navigationExtras);
  }

  onSearch(e) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
          search: e.target.value,
          group: this.selected_group
      },
      queryParamsHandling: 'merge'
    };
    this.router.navigate(['/attendance-status'], navigationExtras);
  }

  onRefresh() {
    if (!this.search && !this.selected_group) {
      this.getAttendanceStatus(this.user._id, this.getStaffIds(this.search), this.selected_group);
    } else {
      this.getAttendanceStatus(null, this.getStaffIds(this.search), this.selected_group);
    }
  }

  // get the staff ids from stafflist based on search
  getStaffIds(search) {
    if (!search || search == "") { return []; }

    search = search.toLowerCase();

    let result = this.staffs.filter(staff => staff['name'].toLowerCase().includes(search) || staff['display_name'].toLowerCase().includes(search));
    let staffIds = result.map(staff => staff._id);
    return staffIds;
  }

  morning_meeting_updated() {
    this.show_morning_meeting_notif = true;
    setTimeout(() => {this.show_morning_meeting_notif = false}, 1000)
  }

  // addMoreRows() {
  //   let lengtharray = [];
  //   Object.keys(this.statuses).forEach(key => lengtharray.push({ key: key, length: this.statuses[key].length }))
  //   const row = lengtharray.reduce((a, b) => (a.length > b.length) ? a : b);
  //   Object.keys(this.statuses).forEach(
  //     key => {
  //       const length = row.length - this.statuses[key].length;
  //       for (let x = 0; x < length; x++) {
  //         this.statuses[key].push('')
  //       }
  //     }
  //   );

  //   const works = this.statuses.work;
  //   const breaks = this.statuses.break;
  //   const outs = this.statuses.out;
  //   const leaves = this.statuses.leave;s
  //   for (let x = 0; x < row.length; x++) {
  //     this.finalData.push({
  //       work: works[x] ? works[x] : '',
  //       break: breaks[x] ? breaks[x] : '',
  //       out: outs[x] ? outs[x] : '',
  //       leave: leaves[x] ? leaves[x] : ''
  //     })
  //   }
  // }

  queryParamsHandler(params: Params) {
    this.search = params['search'] || '';
    this.selected_group = params['group'] || '';
    
    if (!this.search && !this.selected_group) {
      this.getAttendanceStatus(this.user._id, this.getStaffIds(this.search), this.selected_group);
    } else {
      this.getAttendanceStatus(null, this.getStaffIds(this.search), this.selected_group);
    }
  }

  public open(dynamicContent:string = "勤怠ログを出力") {
    const config = new TemplateModalConfig<IContext, string, string>(this.modalTemplate);

    config.closeResult = "closed!";
    config.context = { data: dynamicContent };

    this.modalService
        .open(config)
        .onApprove(result => { this.downloadAttendanceStatus(moment(this._from).format("YYYY-MM-DD"), moment(this._to).format("YYYY-MM-DD")) })
        .onDeny(result => { console.log('cancel')});
  }

  downloadAttendanceStatus(from, to) {
    this.attendanceStatusService.downloadAttendanceStatus(from, to, this.user._id).subscribe(data => {
      let newBlob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const file = window.URL.createObjectURL(newBlob);
      
      let link = document.createElement('a');
      link.href = file;
      link.download = "Attendance Status.xlsx";
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    });
  }

  // =============== Morning table functions =============== //
  // showNoTimeStampStaffs() {
  //   if (this.showAllStaffs == false) { return; }

  //   this.showAllStaffs = false;
  //   this.getMorningMeeting();
  // }

  // onShowAllStaffs() {
  //   if (this.showAllStaffs == true) { return; }
  //   this.showAllStaffs = true;

  //   this.getMorningMeeting();
  // }

  // getMorningMeeting() {
  //   let staffId = this.user._id;
  //   this.morningMeetingService.getMorningMeeting(staffId, this.showAllStaffs, this.tz_offset).subscribe(
  //     res => {
  //       this.morningMeetings = res['data'];
  //     },
  //     error => {
  //       console.log(error);
  //       alert(error);
  //     },
  //   )
  // }

  // onUpdateComment(event: any, meetingId) {
  //   let comment = event.target.value;

  //   // update the comment right away
  //   if (event.keyCode == 13) {
  //     this.updateComment(comment, meetingId);
  //     return;
  //   }

  //   // if updating comment on other staff
  //   if (meetingId == this.pendingUpdateMeetingId) {
  //     clearTimeout(this.updateTimeout);
  //   } else {
  //     this.pendingUpdateMeetingId = meetingId;
  //   }
    
  //   // wait 1.5 seconds before it will send update to db
  //   this.updateTimeout = setTimeout(() => {
  //     this.updateComment(comment, meetingId);
  //     this.pendingUpdateMeetingId = '';
  //   }, 1500);

  // }

  // updateComment(comment, meetingId) {
  //   this.morningMeetingService.updateMorningMeeting(meetingId, comment, null).subscribe(
  //     res => {
  //       console.log(res['message']);
  //     }, 
  //     error => {
  //       alert(error);
  //     }
  //   )
  // }

  // toggleAbsent(e, meetingId) {
  //   // console.log(e.target.checked, meetingId);
  //   let absent = e.target.checked;
  //   this.morningMeetingService.updateMorningMeeting(meetingId, null, absent).subscribe(
  //     res => {
  //       // alert(res['message']);
  //     }, 
  //     error => {
  //       alert(error);
  //     }
  //   )
  // }

}
